




































































































































































import Vue from './report.mixin'
import {
  PatchTemplate,
  GetTemplate,
  DeleteTemplate,
  DownloadTemplate,
  DuplicateTemplate,
  Template,
} from '@/api/report'

interface Field {
  function: string
  field: string
  alias: string
}

import FieldEditor from './fields.vue'

export default Vue.extend({
  name: 'EditReport',
  components: { FieldEditor },
  data() {
    return {
      id: 0,
      form: {
        name: '',
        query: '',
        timeGroup: '',
        timeFormat: 'YYYY-MM-DD hh:mm:ss',
        fieldTime1Format: 'YYYY-MM-DD',
        fieldTime2Format: 'hh:mm:ss',
        sheetname: '',
        dataDuration: '',
        monthlyReport: false,
      } as Template,
      file: undefined as File | undefined,
      duplicateDialogVisible: false,
      newName: 'template copy',
    }
  },

  methods: {
    showDuplicateDialog() {
      this.newName = this.form.name + '_COPY'
      this.duplicateDialogVisible = true
    },

    async duplicateTemplate() {
      const newTemplate = await DuplicateTemplate(this.id, this.newName)
      this.$router.push(`/cems/setting/report/${newTemplate.id}/edit`)
      this.id = parseInt(this.$route.params.id)
      await this.getReport()
    },

    async patchTemplate() {
      await PatchTemplate(
        this.id,
        this.form,
        this.file as File,
        this.form.sheetname
      )
      this.gotoReport()
    },

    async deleteTemplate() {
      await DeleteTemplate(this.id)
      this.gotoReport()
    },

    async getReport() {
      this.form = await GetTemplate(this.id)
    },

    async exportTemplate() {
      await DownloadTemplate(this.id)
    },

    gotoReport() {
      this.$router.push('/cems/setting/report')
    },
  },

  async created() {
    this.id = parseInt(this.$route.params.id)
    await this.getReport()
  },
})
